<template>
	<modal body-classes="p-0" :show="open !== null" @close="close">
		<card type="secondary" class="border-0 mb-0">
			<template slot="header">
				<h2 class="text-center mb-0">แก้ไขข้อมูล</h2>
			</template>
			<template>
				<form @submit.prevent="saveBank">
					<base-checkbox v-model="acc.enable" class="mb-3">
						เปิดใช้งาน
					</base-checkbox>
					<base-checkbox v-model="acc.hide" class="mb-3">
						ซ่อนจากเว็บไซต์
					</base-checkbox>

					<base-input label="ชื่อบัญชี" placeholder="ชื่อบัญชี" v-model="acc.accountName" />
					<base-input label="เลขบัญชี" placeholder="เลขบัญชี" v-model="acc.accountNumber" />
					<base-input label="API URL" v-model="acc.apiURL" readonly v-if="acc.apiURL !== ''" />

					<div v-if="acc.bank === 'scb'">
						<hr />
						<h2 class="mb-3">ตั้งค่า SCB Easy Net</h2>
						<base-input label="ชื่อผู้ใช้งาน" placeholder="ชื่อผู้ใช้งาน" v-model="acc.meta.username" />
						<base-input label="รหัสผ่าน" placeholder="รหัสผ่าน" v-model="acc.meta.password" />
					</div>

					<div class="mt-3">
						<base-button native-type="submit" type="default" :disabled="loading">
							บันทึกข้อมูล
						</base-button>
					</div>
				</form>
			</template>
		</card>
	</modal>
</template>

<script>
import { Select, Option } from 'element-ui'

import SettingService from '../../services/setting.service'

export default {
	props: ['open', 'bankAccount'],
	components: {
		[Select.name]: Select,
		[Option.name]: Option,
	},
	data() {
		return {
			loading: false,
			acc: {},
		}
	},
	methods: {
		close() {
			this.$emit('close')
		},
		saveBank() {
			this.loading = true
			SettingService.saveBank(this.acc)
				.then(({ message }) => {
					this.$notify({
						type: 'success',
						message: message,
					})

					this.$emit('close')
					this.$emit('reloadSetting')
				})
				.catch(({ message }) => {
					this.$notify({
						type: 'danger',
						message: message,
					})
				})
				.finally(() => {
					this.loading = false
				})
		},
	},
	watch: {
		open(v) {
			this.acc = Object.assign(v ? { oldAccountNumber: v.accountNumber } : {}, v)

			// reset encrpyed password
			if (this.acc.meta.password) {
				this.acc.meta.password = ''
			}
		},
	},
}
</script>
